module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "register-form"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    attrs: {
      "type": "text",
      "placeholder": "User Name...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordVerify),
      expression: "passwordVerify"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Verify Password...",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.passwordVerify)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordVerify = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gender-switcher"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender-male",
      "name": "gender",
      "value": "Male"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Male")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Male"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender-male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender-female",
      "name": "gender",
      "value": "Female"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Female")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Female"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender-female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('div', {
    staticClass: "agree-to-toc checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreesToToc),
      expression: "agreesToToc"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agree-check",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.agreesToToc) ? _vm._i(_vm.agreesToToc, null) > -1 : (_vm.agreesToToc)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.agreesToToc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreesToToc = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreesToToc = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreesToToc = $$c
        }
      }, function($event) {
        _vm.errors = []
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "agree-check"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "agree-to-age checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreesToAge),
      expression: "agreesToAge"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agree-age",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.agreesToAge) ? _vm._i(_vm.agreesToAge, null) > -1 : (_vm.agreesToAge)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.agreesToAge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreesToAge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreesToAge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreesToAge = $$c
        }
      }, function($event) {
        _vm.errors = []
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "agree-age"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "agree-age"
    }
  }, [_vm._v("I am 13+ years old")])]), _vm._v(" "), (_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Register")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "agree-check"
    }
  }, [_vm._v("I agree with the\n            "), _c('a', {
    attrs: {
      "href": "/Doc/TOC",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v("\n            and\n            "), _c('a', {
    attrs: {
      "href": "/Doc/PrivacyPolicy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d62c693"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HomePage/RegisterForm.vue
// module id = 403
// module chunks = 1